import store from '@/store';
import Client from '@/classes/Api/Client';

const unauthorizedRoutes = ['auth.login', 'auth.register', 'auth.register.info'];

function refreshToken(to, from, next) {
  Client.refreshToken().then(
    () => requireAuthMiddleware(to, from, next),
    () => {
      store.commit('Auth/loadingStatus', false);
      next({name: 'auth.login'});
    }
  );
}

function requireAuthMiddleware(to, from, next) {
  if (
    unauthorizedRoutes.indexOf(to.name) === -1 &&
    !store.state.Auth.authorized
  ) {
    store.commit('Auth/loadingStatus', true);

    store.dispatch('Auth/loadProfile').then(
      () => {
        store.commit('Auth/loadingStatus', false);
        next();
      },
      (error) => {
        let response = error.response;
        if (response.status === 401) {
          refreshToken(to, from, next);
        } else {
          store.commit('Auth/loadingStatus', false);
          next({name: 'auth.login'});
        }
      }
    );
  } else {
    next();
  }
}

export default requireAuthMiddleware;
